<template>
    <div>
        <div class="flex items-center gap-4 mb-4">
            <h3 class="text-2xl text-dark font-bold">
                Latest tyre news
            </h3>

            <AppButton v-if="route().has('news.index')" size="small" :href="route('news.index')">
                View All
            </AppButton>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <a v-for="article of news" :href="route('news.show', article)" class="group">
                <img :src="article.image ?? '/images/misc/default_news.jpg'"
                     class="w-full aspect-video rounded-lg lazy mb-4">

                <span class="underline text-lg text-black group-hover:text-primary">{{ article.title }}</span>

                <div class="text-placeholder text-sm mt-4">
                    {{ dayjs(article.created_at).format("Do MMMM YYYY") }}
                </div>
            </a>
        </div>
    </div>
</template>

<script setup>
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import AppButton from "@/Components/AppButton";

dayjs.extend(advancedFormat);

const props = defineProps({
    news: Array
});
</script>

<style scoped>

</style>
